import "./App.scss";
import { PathPopulateProvider } from "./components/tools/PathPopulateContext";
import { PathPopulateControls } from "./components/tools/PathPopulateControls";
import { PathPopulateViewer } from "./components/tools/PathPopulateViewer";
import { FillPackProvider } from "./components/tools/FillPackContext";
import { FillPackControls } from "./components/tools/FillPackControls";
import { FillPackViewer } from "./components/tools/FillPackViewer";
import { PrimitivePointsProvider } from "./components/tools/PrimitivePointsContext";
import { PrimitivePointsControls } from "./components/tools/PrimitivePointsControls";
import { PrimitivePointsViewer } from "./components/tools/PrimitivePointsViewer";
import { PanelSelector } from "./components/reusable/PanelSelector";
import { ArcConnectionsPanel } from "./components/tools/ArcConnectionsPanel";
import { ArcConnectionsViewer } from "./components/tools/ArcConnectionsViewer";
import { ArcConnectionsProvider } from "./components/tools/ArcConnectionsContext";
import { RectNodeConnectionsPanel } from "./components/tools/RectNodeConnectionsPanel";
import { RectNodeConnectionsViewer } from "./components/tools/RectNodeConnectionsViewer";
import { RectNodeConnectionsProvider } from "./components/tools/RectNodeConnectionsContext";
import { TextNoiseFillProvider } from "./components/tools/TextNoiseFillContext";
import { TextNoiseFillControls } from "./components/tools/TextNoiseFillControls";
import { TextNoiseFillViewer } from "./components/tools/TextNoiseFillViewer";
import { PointDistortionProvider } from "./components/tools/PointDistortionContext";
import { PointDistortionControls } from "./components/tools/PointDistortionControls";
import { PointDistortionViewer } from "./components/tools/PointDistortionViewer";
import { GridEditorProvider } from "./components/tools/GridEditorContext";
import { GridEditorControls } from "./components/tools/GridEditorControls";
import { GridEditorViewer } from "./components/tools/GridEditorViewer";
import { TraitConnectionsProvider } from "./components/tools/TraitConnectionsContext";
import { TraitConnectionsPanel } from "./components/tools/TraitConnectionsPanel";
import { TraitConnectionsViewer } from "./components/tools/TraitConnectionsViewer";
import { SvgToRasterProvider } from "./components/tools/SvgToRasterContext";
import { SvgToRasterControls } from "./components/tools/SvgToRasterControls";
import { SvgToRasterViewer } from "./components/tools/SvgToRasterViewer";
import { AsciiArtProvider } from "./components/tools/AsciiArtContext";
import { AsciiArtControls } from "./components/tools/AsciiArtControls";
import { AsciiArtViewer } from "./components/tools/AsciiArtViewer";
import { LuminanceGridProvider } from "./components/tools/LuminanceGridContext";
import { LuminanceGridControls } from "./components/tools/LuminanceGridControls";
import { LuminanceGridViewer } from "./components/tools/LuminanceGridViewer";
import { FontMixerProvider } from "./components/tools/FontMixerContext";
import { FontMixerControls } from "./components/tools/FontMixerControls";
import { FontMixerViewer } from "./components/tools/FontMixerViewer";
import { BlobFieldProvider } from "./components/tools/BlobFieldContext";
import { BlobFieldControls } from "./components/tools/BlobFieldControls";
import { BlobFieldViewer } from "./components/tools/BlobFieldViewer";
import { FlowFieldProvider } from "./components/tools/FlowFieldContext";
import { FlowFieldControls } from "./components/tools/FlowFieldControls";
import { FlowFieldViewer } from "./components/tools/FlowFieldViewer";
import { DomainWarpProvider } from "./components/tools/DomainWarpContext";
import { DomainWarpControls } from "./components/tools/DomainWarpControls";
import { DomainWarpViewer } from "./components/tools/DomainWarpViewer";
import { DisplacementMapProvider } from "./components/tools/DisplacementMapContext";
import { DisplacementMapControls } from "./components/tools/DisplacementMapControls";
import { DisplacementMapViewer } from "./components/tools/DisplacementMapViewer";
import { SuperformulaProvider } from "./components/tools/SuperformulaContext";
import { SuperformulaControls } from "./components/tools/SuperformulaControls";
import { SuperformulaViewer } from "./components/tools/SuperformulaViewer";
import { TopographicMapProvider } from "./components/tools/TopographicMapContext";
import { TopographicMapControls } from "./components/tools/TopographicMapControls";
import { TopographicMapViewer } from "./components/tools/TopographicMapViewer";
import { NestedGridProvider } from "./components/tools/NestedGridContext";
import { NestedGridControls } from "./components/tools/NestedGridControls";
import { NestedGridViewer } from "./components/tools/NestedGridViewer";
import { VoronoiProvider } from "./components/tools/VoronoiContext";
import { VoronoiControls } from "./components/tools/VoronoiControls";
import { VoronoiViewer } from "./components/tools/VoronoiViewer";
import { PathAgentsProvider } from "./components/tools/PathAgentsContext";
import { PathAgentsControls } from "./components/tools/PathAgentsControls";
import { PathAgentsViewer } from "./components/tools/PathAgentsViewer";
import { FlowAgentsProvider } from "./components/tools/FlowAgentsContext";
import { FlowAgentsControls } from "./components/tools/FlowAgentsControls";
import { FlowAgentsViewer } from "./components/tools/FlowAgentsViewer";
import { ChannelSplitProvider } from "./components/tools/ChannelSplitContext";
import { ChannelSplitControls } from "./components/tools/ChannelSplitControls";
import { ChannelSplitViewer } from "./components/tools/ChannelSplitViewer";
import { DistortionGridProvider } from "./components/tools/DistortionGridContext";
import { DistortionGridControls } from "./components/tools/DistortionGridControls";
import { DistortionGridViewer } from "./components/tools/DistortionGridViewer";
import { SymbolGeneratorProvider } from "./components/tools/SymbolGeneratorContext";
import { SymbolGeneratorControls } from "./components/tools/SymbolGeneratorControls";
import { SymbolGeneratorViewer } from "./components/tools/SymbolGeneratorViewer";
import { PixelSvgCanvasProvider } from "./components/tools/PixelSvgCanvasContext";
import { PixelSvgCanvasControls } from "./components/tools/PixelSvgCanvasControls";
import { PixelSvgCanvasViewer } from "./components/tools/PixelSvgCanvasViewer";
import { ArtbrushSvgCanvasProvider } from "./components/tools/ArtbrushSvgCanvasContext";
import { ArtbrushSvgCanvasControls } from "./components/tools/ArtbrushSvgCanvasControls";
import { ArtbrushSvgCanvasViewer } from "./components/tools/ArtbrushSvgCanvasViewer";
import { GridCellWrapperProvider } from "./components/tools/GridCellWrapperContext";
import { GridCellWrapperControls } from "./components/tools/GridCellWrapperControls";
import { GridCellWrapperViewer } from "./components/tools/GridCellWrapperViewer";
import { NesGlitchProvider } from "./components/tools/NesGlitchContext";
import { NesGlitchControls } from "./components/tools/NesGlitchControls";
import { NesGlitchViewer } from "./components/tools/NesGlitchViewer";
import { PolarGridCellsProvider } from "./components/tools/PolarGridCellsContext";
import { PolarGridCellsControls } from "./components/tools/PolarGridCellsControls";
import { PolarGridCellsViewer } from "./components/tools/PolarGridCellsViewer";
import { LatticeDeformProvider } from "./components/tools/LatticeDeformContext";
import { LatticeDeformControls } from "./components/tools/LatticeDeformControls";
import { LatticeDeformViewer } from "./components/tools/LatticeDeformViewer";
import { PixelStretchProvider } from "./components/tools/PixelStretchContext";
import { PixelStretchControls } from "./components/tools/PixelStretchControls";
import { PixelStretchViewer } from "./components/tools/PixelStretchViewer";
import { GridCubes3dProvider } from "./components/tools/GridCubes3dContext";
import { GridCubes3dControls } from "./components/tools/GridCubes3dControls";
import { GridCubes3dViewer } from "./components/tools/GridCubes3dViewer";
import { SilhouetteExtractorProvider } from "./components/tools/SilhouetteExtractorContext";
import { SilhouetteExtractorControls } from "./components/tools/SilhouetteExtractorControls";
import { SilhouetteExtractorViewer } from "./components/tools/SilhouetteExtractorViewer";
import { VolumeBuilder3dProvider } from "./components/tools/VolumeBuilder3dContext";
import { VolumeBuilder3dControls } from "./components/tools/VolumeBuilder3dControls";
import { VolumeBuilder3dViewer } from "./components/tools/VolumeBuilder3dViewer";
import { SvgDiagram2DProvider } from "./components/tools/SvgDiagram2DContext";
import { SvgDiagram2DControls } from "./components/tools/SvgDiagram2DControls";
import { SvgDiagram2DViewer } from "./components/tools/SvgDiagram2DViewer";
import { AppPanelLayout } from "./components/reusable/AppPanelLayout";

function App() {
    return (
        <div className="app-root">
            <main className="app-main">
                <PanelSelector>
                    {(activePanel) => {
                        if (activePanel === "object-along-path") {
                            return (
                                <PathPopulateProvider
                                    initialDistance={10}
                                    initialScale={5}
                                >
                                    <AppPanelLayout
                                        viewer={<PathPopulateViewer />}
                                        controls={<PathPopulateControls />}
                                    />
                                </PathPopulateProvider>
                            );
                        }
                        if (activePanel === "object-fill-pack") {
                            return (
                                <FillPackProvider
                                    initialSpacing={12}
                                    initialScale={40}
                                >
                                    <AppPanelLayout
                                        viewer={<FillPackViewer />}
                                        controls={<FillPackControls />}
                                    />
                                </FillPackProvider>
                            );
                        }
                        if (activePanel === "primitive-points") {
                            return (
                                <PrimitivePointsProvider>
                                    <AppPanelLayout
                                        viewer={<PrimitivePointsViewer />}
                                        controls={<PrimitivePointsControls />}
                                    />
                                </PrimitivePointsProvider>
                            );
                        }
                        if (activePanel === "text-noise-fill") {
                            return (
                                <TextNoiseFillProvider>
                                    <AppPanelLayout
                                        viewer={<TextNoiseFillViewer />}
                                        controls={<TextNoiseFillControls />}
                                    />
                                </TextNoiseFillProvider>
                            );
                        }
                        if (activePanel === "point-distortion") {
                            return (
                                <PointDistortionProvider>
                                    <AppPanelLayout
                                        viewer={<PointDistortionViewer />}
                                        controls={<PointDistortionControls />}
                                    />
                                </PointDistortionProvider>
                            );
                        }
                        if (activePanel === "grid-editor") {
                            return (
                                <GridEditorProvider>
                                    <AppPanelLayout
                                        viewer={<GridEditorViewer />}
                                        controls={<GridEditorControls />}
                                    />
                                </GridEditorProvider>
                            );
                        }
                        if (activePanel === "trait-connections") {
                            return (
                                <TraitConnectionsProvider>
                                    <AppPanelLayout
                                        viewer={<TraitConnectionsViewer />}
                                        controls={<TraitConnectionsPanel />}
                                    />
                                </TraitConnectionsProvider>
                            );
                        }
                        if (activePanel === "svg-to-raster") {
                            return (
                                <SvgToRasterProvider>
                                    <AppPanelLayout
                                        viewer={<SvgToRasterViewer />}
                                        controls={<SvgToRasterControls />}
                                    />
                                </SvgToRasterProvider>
                            );
                        }
                        if (activePanel === "channel-split") {
                            return (
                                <ChannelSplitProvider>
                                    <AppPanelLayout
                                        viewer={<ChannelSplitViewer />}
                                        controls={<ChannelSplitControls />}
                                    />
                                </ChannelSplitProvider>
                            );
                        }
                        if (activePanel === "distortion-grid") {
                            return (
                                <DistortionGridProvider>
                                    <AppPanelLayout
                                        viewer={<DistortionGridViewer />}
                                        controls={<DistortionGridControls />}
                                    />
                                </DistortionGridProvider>
                            );
                        }
                        if (activePanel === "lattice-deform") {
                            return (
                                <LatticeDeformProvider>
                                    <AppPanelLayout
                                        viewer={<LatticeDeformViewer />}
                                        controls={<LatticeDeformControls />}
                                    />
                                </LatticeDeformProvider>
                            );
                        }
                        if (activePanel === "pixel-stretch") {
                            return (
                                <PixelStretchProvider>
                                    <AppPanelLayout
                                        viewer={<PixelStretchViewer />}
                                        controls={<PixelStretchControls />}
                                    />
                                </PixelStretchProvider>
                            );
                        }
                        if (activePanel === "ascii-art") {
                            return (
                                <AsciiArtProvider>
                                    <AppPanelLayout
                                        viewer={<AsciiArtViewer />}
                                        controls={<AsciiArtControls />}
                                    />
                                </AsciiArtProvider>
                            );
                        }
                        if (activePanel === "luminance-grid") {
                            return (
                                <LuminanceGridProvider>
                                    <AppPanelLayout
                                        viewer={<LuminanceGridViewer />}
                                        controls={<LuminanceGridControls />}
                                    />
                                </LuminanceGridProvider>
                            );
                        }
                        if (activePanel === "font-mixer") {
                            return (
                                <FontMixerProvider>
                                    <AppPanelLayout
                                        viewer={<FontMixerViewer />}
                                        controls={<FontMixerControls />}
                                    />
                                </FontMixerProvider>
                            );
                        }
                        if (activePanel === "blob-field") {
                            return (
                                <BlobFieldProvider>
                                    <AppPanelLayout
                                        viewer={<BlobFieldViewer />}
                                        controls={<BlobFieldControls />}
                                    />
                                </BlobFieldProvider>
                            );
                        }
                        if (activePanel === "flow-field") {
                            return (
                                <FlowFieldProvider>
                                    <AppPanelLayout
                                        viewer={<FlowFieldViewer />}
                                        controls={<FlowFieldControls />}
                                    />
                                </FlowFieldProvider>
                            );
                        }
                        if (activePanel === "domain-warp") {
                            return (
                                <DomainWarpProvider>
                                    <AppPanelLayout
                                        viewer={<DomainWarpViewer />}
                                        controls={<DomainWarpControls />}
                                    />
                                </DomainWarpProvider>
                            );
                        }
                        if (activePanel === "displacement-map") {
                            return (
                                <DisplacementMapProvider>
                                    <AppPanelLayout
                                        viewer={<DisplacementMapViewer />}
                                        controls={<DisplacementMapControls />}
                                    />
                                </DisplacementMapProvider>
                            );
                        }
                        if (activePanel === "superformula") {
                            return (
                                <SuperformulaProvider>
                                    <AppPanelLayout
                                        viewer={<SuperformulaViewer />}
                                        controls={<SuperformulaControls />}
                                    />
                                </SuperformulaProvider>
                            );
                        }
                        if (activePanel === "topographic-map") {
                            return (
                                <TopographicMapProvider>
                                    <AppPanelLayout
                                        viewer={<TopographicMapViewer />}
                                        controls={<TopographicMapControls />}
                                    />
                                </TopographicMapProvider>
                            );
                        }
                        if (activePanel === "nested-grid") {
                            return (
                                <NestedGridProvider>
                                    <AppPanelLayout
                                        viewer={<NestedGridViewer />}
                                        controls={<NestedGridControls />}
                                    />
                                </NestedGridProvider>
                            );
                        }
                        if (activePanel === "voronoi-diagram") {
                            return (
                                <VoronoiProvider>
                                    <AppPanelLayout
                                        viewer={<VoronoiViewer />}
                                        controls={<VoronoiControls />}
                                    />
                                </VoronoiProvider>
                            );
                        }
                        if (activePanel === "polar-grid-cells") {
                            return (
                                <PolarGridCellsProvider>
                                    <AppPanelLayout
                                        viewer={<PolarGridCellsViewer />}
                                        controls={<PolarGridCellsControls />}
                                    />
                                </PolarGridCellsProvider>
                            );
                        }
                        if (activePanel === "flow-agents") {
                            return (
                                <FlowAgentsProvider>
                                    <AppPanelLayout
                                        viewer={<FlowAgentsViewer />}
                                        controls={<FlowAgentsControls />}
                                    />
                                </FlowAgentsProvider>
                            );
                        }
                        if (activePanel === "path-agents") {
                            return (
                                <PathAgentsProvider>
                                    <AppPanelLayout
                                        viewer={<PathAgentsViewer />}
                                        controls={<PathAgentsControls />}
                                    />
                                </PathAgentsProvider>
                            );
                        }
                        if (activePanel === "symbol-generator") {
                            return (
                                <SymbolGeneratorProvider>
                                    <AppPanelLayout
                                        viewer={<SymbolGeneratorViewer />}
                                        controls={<SymbolGeneratorControls />}
                                    />
                                </SymbolGeneratorProvider>
                            );
                        }
                        if (activePanel === "pixel-svg-canvas") {
                            return (
                                <PixelSvgCanvasProvider>
                                    <AppPanelLayout
                                        viewer={<PixelSvgCanvasViewer />}
                                        controls={<PixelSvgCanvasControls />}
                                    />
                                </PixelSvgCanvasProvider>
                            );
                        }
                        if (activePanel === "artbrush-svg-canvas") {
                            return (
                                <ArtbrushSvgCanvasProvider>
                                    <AppPanelLayout
                                        viewer={<ArtbrushSvgCanvasViewer />}
                                        controls={<ArtbrushSvgCanvasControls />}
                                    />
                                </ArtbrushSvgCanvasProvider>
                            );
                        }
                        if (activePanel === "grid-cell-wrapper") {
                            return (
                                <GridCellWrapperProvider>
                                    <AppPanelLayout
                                        viewer={<GridCellWrapperViewer />}
                                        controls={<GridCellWrapperControls />}
                                    />
                                </GridCellWrapperProvider>
                            );
                        }
                        if (activePanel === "nes-glitch") {
                            return (
                                <NesGlitchProvider>
                                    <AppPanelLayout
                                        viewer={<NesGlitchViewer />}
                                        controls={<NesGlitchControls />}
                                    />
                                </NesGlitchProvider>
                            );
                        }
                        if (activePanel === "grid-cubes-3d") {
                            return (
                                <GridCubes3dProvider>
                                    <AppPanelLayout
                                        viewer={<GridCubes3dViewer />}
                                        controls={<GridCubes3dControls />}
                                    />
                                </GridCubes3dProvider>
                            );
                        }
                        if (activePanel === "silhouette-extractor") {
                            return (
                                <SilhouetteExtractorProvider>
                                    <AppPanelLayout
                                        viewer={<SilhouetteExtractorViewer />}
                                        controls={<SilhouetteExtractorControls />}
                                    />
                                </SilhouetteExtractorProvider>
                            );
                        }
                        if (activePanel === "volume-builder-3d") {
                            return (
                                <VolumeBuilder3dProvider>
                                    <AppPanelLayout
                                        viewer={<VolumeBuilder3dViewer />}
                                        controls={<VolumeBuilder3dControls />}
                                    />
                                </VolumeBuilder3dProvider>
                            );
                        }
                        if (activePanel === "svg-diagram-2d") {
                            return (
                                <SvgDiagram2DProvider>
                                    <AppPanelLayout
                                        viewer={<SvgDiagram2DViewer />}
                                        controls={<SvgDiagram2DControls />}
                                    />
                                </SvgDiagram2DProvider>
                            );
                        }
                        if (activePanel === "rect-node-connections") {
                            return (
                                <RectNodeConnectionsProvider>
                                    <AppPanelLayout
                                        viewer={<RectNodeConnectionsViewer />}
                                        controls={<RectNodeConnectionsPanel />}
                                    />
                                </RectNodeConnectionsProvider>
                            );
                        }
                        return (
                            <ArcConnectionsProvider initialBezierAngle={45}>
                                <AppPanelLayout
                                    viewer={<ArcConnectionsViewer />}
                                    controls={<ArcConnectionsPanel />}
                                />
                            </ArcConnectionsProvider>
                        );
                    }}
                </PanelSelector>
            </main>
        </div>
    );
}

export default App;
